import baseApplicationItem from './baseApplicationItem'
import {merge} from 'lodash'

const module = {
  endpoint: 'customer',
  getNew: {
    id: null,
    firstName: null,
    lastName: null,
    businessName: '',
    vatNumber: '',
    address: '',
    profile: {},
    // profileId: 1,
    email: '',
    deleted: false
  },
  tableInfo: {
    tableFields: [
      {
        name: '__component:badge-deleted-column',
        title: '',
        dataClass: 'text-center'
      },
      {
        name: '__checkbox',
        title: '',
        class: 'primary'
      },
      {
        name: 'id',
        title: 'id',
        sortField: 'id'
      },
      {
        name: 'firstName',
        title: 'nome',
        sortField: 'firstName'
      },
      {
        name: 'lastName',
        title: 'cognome',
        sortField: 'lastName'
      },
      {
        name: 'email',
        title: 'e-mail',
        sortField: 'email'
      },
      {
        name: '__component:actions-column',
        title: '',
        dataClass: 'text-center'
      }
    ],
    sortFunctions: {
      // 'name': function (item1, item2) {
      //   return item1 >= item2 ? 1 : -1
      // }
    }
  },
}

export default merge(module, baseApplicationItem)



// WEBPACK FOOTER //
// ./src/application/users.js